import React from 'react'
import {Link} from "react-router-dom"
import {
    changeHandler,
    formatDate, getPathBack,
    objectLang,
} from "../functions"

export class NoteCardClass extends React.Component {

    render() {

        const {note, owner, removeNoteHandler, shareHandler} = this.props

        let lang = objectLang().language
        const l = lang.lang

        let share, isShare
        if (!note.accessLink) {
            share = lang.body.contextMenu.share
            isShare = 'Записка доступна только Вам'
        } else {
            share = lang.body.contextMenu.noShare
            isShare = 'Записка доступна по ссылке'
        }

        return (
            <>
                <div className={'container col col-sm-12 col-xl-6'}>
                    <form className={'rounded form-link-detail mt-2'}>
                        <div className={"mb-5 ms-2 me-1 mt-3 d-flex justify-content-between"}>
                            <div className={"d-flex justify-content-center w-100"}>
                                <Link to={`/${l}/note/open/${note["_id"]}`}
                                      className={"btn btn-success w-100 ms-2 me-1 fs-3 p-0"}>
                                    {note.name}
                                </Link>
                            </div>
                            <Link to={getPathBack()}
                                  id={"button-close-link"}
                                  className={"btn-close fs-2 p-2 m-0 me-1"}
                                  aria-label={"Close"}>
                            </Link>
                        </div>
                        <p
                            id={"p-date-created"}
                            className={"mt-3 ms-3 mb-1"}>
                            {`${lang.body.linkPage.createdDate}`}&nbsp;
                            <strong>{formatDate(note["dateCreated"]).date}</strong>
                        </p>

                        <div className={'text-center mt-3'}>
                            <p id={'share'}
                               className={'m-auto ms-2 p-0'}>
                                {isShare}&nbsp;
                                <Link to={''}
                                      className={'text-decoration-none border-1'}
                                      onClick={shareHandler}>
                                    {share}
                                </Link>
                            </p>
                            {note.accessLink && <div className={'mt-2 ms-3 me-3 d-flex'}>
                                <input id={'share-link'}
                                       type={"text"}
                                       className={"form-control"}
                                       disabled={true}
                                       defaultValue={note.accessLink}
                                />
                                <div id={"div-paste-name"}
                                     className={"btn-paste btn btn-secondary bg-white"}>
                                    <i id={'btn-copy'} className={`fa-regular fa-copy text-success`}
                                       onClick={() => {
                                           navigator.clipboard.writeText(note.accessLink)
                                               .then(() => {
                                                   const i = document.getElementById('btn-copy')
                                                   i.classList.remove('fa-regular')
                                                   i.classList.remove('fa-copy')
                                                   i.classList.add('fa-solid')
                                                   i.classList.add('fa-check')
                                               })
                                               .catch(err => {
                                                   alert(err)
                                               })
                                       }}
                                    />
                                </div>
                            </div>}
                        </div>

                        <fieldset className={'teal m-3 p-3'}>

                            <div id={"divFrom"} className={"mb-1"}>
                                <label
                                    id={"owner-label"}
                                    htmlFor={"owner"}
                                    className={"form-label"}>
                                    {"Владелец записки"}
                                </label>
                                <h4
                                    id={"owner"}
                                    className={`mb-3 ms-3`}
                                    placeholder={`${lang.body.notePage.placeholderSiteLink}`}>
                                    {`${owner.name}`}
                                </h4>
                            </div>

                            <div id={"divName"} className={"mb-3"}>
                                <label
                                    id={"label-name"}
                                    htmlFor={"name"}
                                    className={"form-label"}>
                                    {`${lang.body.notePage.labelNoteTitle}`}
                                </label>
                                <input
                                    disabled
                                    type={"text"}
                                    name={"name"}
                                    id={"name"}
                                    defaultValue={`${note.name}`}
                                    onChange={changeHandler}
                                    className={"form-control form-detail"}
                                    placeholder={`${lang.body.folderPage.placeholderName}`}
                                />
                            </div>
                            <div id={"divDescription"} className={"mb-3"}>
                                <label
                                    id={"label-description"}
                                    htmlFor={"description"}
                                    className={"form-label"}>
                                    {`${lang.body.notePage.labelNoteBody}`}
                                </label>
                                <textarea
                                    disabled
                                    name={"body"}
                                    id={"body"}
                                    defaultValue={note.body}
                                    onChange={changeHandler}
                                    className={"form-control form-detail"}
                                    placeholder={`${lang.body.notePage.placeholderNoteBody}`}
                                />
                            </div>
                            <div className={"ms-1 me-1 row row-cols-xl-5 gap-xl-2 justify-content-center"}>
                                <Link to={getPathBack()}
                                      id={"btn-back"}
                                      className={"form-detail-btn btn btn-info mt-2"}>
                                    {`${lang.body.notePage.buttonBack}`}
                                </Link>
                                <Link to={`/${l}/note/open/${note["_id"]}`}
                                      id={"btn-open"}
                                      className={"form-detail-btn btn btn-warning mt-2"}>
                                    {`${lang.body.notePage.buttonOpen}`}
                                </Link>
                                <Link to={``}
                                      id={"btn-delete"}
                                      className={"form-detail-btn btn btn-danger mt-2"}
                                      onClick={removeNoteHandler}>
                                    {`${lang.body.notePage.buttonDelete}`}
                                </Link>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </>
        )
    }
}
